import React from 'react';
import CookiesInfo from "@components/layout/CookiesInfo/Main";

const CookiesInfoContainer = () => {
    return (
        <CookiesInfo/>
    )
}

export default CookiesInfoContainer;